$('input[name=selling_plan_template--19231575146659__main]').change(function(){
 if ($(this).is(":checked")) {
   $getvalue = $(this).val();
   $getquantity = $(this).attr('data-quantity');

   if($getvalue == 'one-time' && $getquantity == 'one'){
     $(".onebtl").attr('href', 'https://nutraville.com/cart/add?id=46170954006691');
     $('.price_one_btl').text('$49');
     $('.pay-price-one').text('$49');
     $('.reveal-txt.one').hide();
   }
   if($getvalue == 'subscribe' && $getquantity == 'one'){ 
     $(".onebtl").attr('href', 'https://nutraville.com/cart/add?items[][id]=46170954006691&items[][variation]=46170954006691&items[][selling_plan]=2561114275');
          $('.price_one_btl').text('$44.10');
        $('.pay-price-one').text('$44.10');
          $('.reveal-txt.one').show();
     
   }
    if($getvalue == 'one-time' && $getquantity == 'three'){
     $(".threebtl").attr('href', 'https://nutraville.com/cart/add?id=46170954039459');
     $('.price_three_btls').text('$39');
      $('.pay-price-three').text('$117');
           $('.reveal-txt.three').hide();
   }
   if($getvalue == 'subscribe' && $getquantity == 'three'){ 
     $(".threebtl").attr('href', 'https://nutraville.com/cart/add?items[][id]=46170954039459&items[][variation]=46170954039459&items[][selling_plan]=2561114275');
         $('.price_three_btls').text('$35.10');
       $('.pay-price-three').text('$105.30');
       $('.reveal-txt.three').show();
   }
    if($getvalue == 'one-time' && $getquantity == 'six'){
     $(".sixbtl").attr('href', 'https://nutraville.com/cart/add?id=46170954072227');
     $('.price_six_btls').text('$29');
             $('.pay-price-six').text('$174');
        $('.reveal-txt.six').hide();
   }
   if($getvalue == 'subscribe' && $getquantity == 'six'){ 
     $(".sixbtl").attr('href', 'https://nutraville.com/cart/add?items[][id]=46170954072227&items[][variation]=46170954072227&items[][selling_plan]=2561114275');
         $('.price_six_btls').text('$26.10');
        $('.pay-price-six').text('$156.60');
      $('.reveal-txt.six').show();
   }
 }
})